import { render, staticRenderFns } from "./ModalDetalhes.vue?vue&type=template&id=6b9d7108&scoped=true"
import script from "./ModalDetalhes.vue?vue&type=script&lang=js"
export * from "./ModalDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhes.vue?vue&type=style&index=0&id=6b9d7108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d7108",
  null
  
)

export default component.exports